import { render, staticRenderFns } from "./CustomersGeneralInformationForm.vue?vue&type=template&id=6491df97&scoped=true&"
import script from "./CustomersGeneralInformationForm.vue?vue&type=script&lang=ts&"
export * from "./CustomersGeneralInformationForm.vue?vue&type=script&lang=ts&"
import style0 from "./CustomersGeneralInformationForm.vue?vue&type=style&index=0&id=6491df97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6491df97",
  null
  
)

export default component.exports